import { useState } from "react";
import { useParams } from "react-router-dom";
import EditVendorForm from "./components/edit-vendor-form/EditVendorForm";
import useMutateVendor from "./hooks/useMutateVendor";
import { useVendor } from "./hooks/useVendor";
import { VendorFormData } from "./components/edit-vendor-form/edit-vendor.schema";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import BaseModal from "../shared/components/BaseModal";
import BaseButton from "components/common/BaseButton";
import { usAdminAppRoutes } from "../../../route-definitions";
import VendorsLoader from "./components/skeletons/VendorsSkeleton";
import ErrorPage from "../shared/components/BaseError";
import EntityPageLayout from "../shared/components/EntityPageLayout";

const EditVendor = () => {
  const intl = useIntl();
  const history = useHistory();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { entityId } = useParams<{
    entityId: string;
  }>();

  const {
    data: vendor,
    isLoading,
    isError,
    error,
    refetch,
  } = useVendor({ vendorId: entityId });

  const { editVendor, editVendorLoading, editVendorError, editVendorSuccess } =
    useMutateVendor({
      id: entityId,
      onEditSuccess: () => {
        setModalIsOpen(true);
      },
      onEditError() {
        setModalIsOpen(true);
      },
    });

  const onSubmit = (data: VendorFormData) => {
    editVendor({ ...data, vendorId: entityId });
  };

  if (isError)
    return (
      <EntityPageLayout headerMessage="usAdmin.editVendor">
        <ErrorPage errorMessage={error} onRetry={refetch} />
      </EntityPageLayout>
    );

  if (isLoading)
    return (
      <EntityPageLayout headerMessage="usAdmin.editVendor">
        <VendorsLoader />
      </EntityPageLayout>
    );

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (editVendorSuccess) {
      history.push(usAdminAppRoutes.vendors);
    }
  };

  const vendorError = Array.isArray(editVendorError?.response?.data?.message)
    ? editVendorError.response.data.message[0]
    : editVendorError?.response?.data?.message;

  return (
    <EntityPageLayout headerMessage="usAdmin.editVendor">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {editVendorSuccess && (
          <h2>
            {intl.formatMessage({ id: "usAdmin.vendorUpdatedSuccessfully" })}
          </h2>
        )}
        {editVendorError && <h2>{vendorError}</h2>}
      </BaseModal>
      <EditVendorForm
        vendor={vendor!}
        onSubmit={onSubmit}
        isSubmitting={editVendorLoading}
      />
    </EntityPageLayout>
  );
};

export default EditVendor;
